export const PROD_EXCHANGE_ENDPOINT = "https://exchange.gemini.com";
export const STAGING_EXCHANGE_ENDPOINT = "https://exchange.sandbox.gemini.com";
